module.exports = __webpack_public_path__ + "img/comercio-beneficio-1.72e056fa.svg";